var map = {
	"./music-instructions.json": 5138,
	"./music-library-intro2024.json": 5139,
	"./music-library-launch2024.json": 5140,
	"./music-progression.json": 5141,
	"./startSourcesAdvanced.json": 5142,
	"./startSourcesSimple.json": 5143,
	"./startSourcesSimple2.json": 5144,
	"./startSourcesTracks.json": 5145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4836;